import { render, staticRenderFns } from "./CustomerDetailEmails.vue?vue&type=template&id=0002a682&scoped=true&"
import script from "./CustomerDetailEmails.vue?vue&type=script&lang=js&"
export * from "./CustomerDetailEmails.vue?vue&type=script&lang=js&"
import style0 from "./CustomerDetailEmails.vue?vue&type=style&index=0&id=0002a682&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0002a682",
  null
  
)

export default component.exports